<template>
	<TeamingDialog :class="classes"
		:show-dialog="showDialog"
		:hide-on-escape="true"
	>
		<div class="body">
			<slot></slot>
		</div>
	</TeamingDialog>
</template>

<script>
import EventsMixin from "../../mixins/EventsMixin";
import TeamingDialog from "../TeamingDialog.vue";

export default {
	name: "SparseDialog",
	mixins: [ EventsMixin, ],
	components: {
		TeamingDialog,
	},
	props: {
		showDialog: {
			type: Boolean,
			required: true,
		},
		mobileVisible: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				"sparse-dialog": true,
				"sparse-dialog--mobile-support": this.mobileVisible,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.sparse-dialog .body {
	position: relative;
	width: 100%;
}
</style>

<style lang="scss">
// dialogs should be hidden on mobile by default
.sparse-dialog.p-dialog {
	display: none;

	@include for-size('md') {
		display: flex;
	}
}

.sparse-dialog.sparse-dialog--mobile-support.p-dialog {
	display: flex;
	width: 95% !important;

	@include for-size('sm') {
		width: unset;
	}
}

.sparse-dialog .p-dialog-content {
	padding: 0 !important;
	height: 100%;
}

body .p-dialog-mask {
	z-index: 0 !important; // kill this overlay for the tombstone

	@include for-size-and-larger('sm') {
		z-index: 1001 !important; // default value
	}
}
</style>
